import { render, staticRenderFns } from "./PsIndicatorNumber.vue?vue&type=template&id=29a25a11&scoped=true&"
import script from "./PsIndicatorNumber.vue?vue&type=script&lang=js&"
export * from "./PsIndicatorNumber.vue?vue&type=script&lang=js&"
import style0 from "./PsIndicatorNumber.vue?vue&type=style&index=0&id=29a25a11&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a25a11",
  null
  
)

export default component.exports